export const getExperimentsTableFilterOptions = (state: Record<string, any>) =>
  state.experiments.index.tableFilterOption.menuItems;
